import { Subscription } from 'rxjs';
import { Component, Input, OnDestroy, OnInit, ViewEncapsulation, TemplateRef, ViewChild, Output, EventEmitter, Inject } from '@angular/core';
import { CarouselComponent } from '../carousel.component';
import { ModalType } from '@challenger6/vm-pattern-library/modal';
import { ButtonType } from '@challenger6/vm-pattern-library/button';
import { LIB_CONFIG } from '../../../lib-config';
import { LibConfig } from '../../../models/lib-config.model';

@Component({
  selector: 'vm-carousel-slide',
  templateUrl: './carousel-slide.component.html',
  styleUrls: ['./carousel-slide.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CarouselSlideComponent implements OnInit, OnDestroy {
  ButtonType = ButtonType;
  @Input() title = '';
  @Input() subtitle = '';
  @Input() media = null;
  @Input() description = '';
  @Input() modal = {
    modalTitle: '',
    modalCopy: '',
    modalActions: [],
  };
  @Input() actions?;
  @Output() next = new EventEmitter();
  @Output() modalNext = new EventEmitter();

  @ViewChild('slideTemplate', { static: false }) slideTemplate: TemplateRef<any>;

  prevCopy;
  nextCopy;
  strapiUrl;

  private carouselSubscription: Subscription;
  issecondaryModalOpen: boolean;
  modalType = ModalType.Large;
  nextAction: {
    id?: string;
    uid?: string;
  };
  
  constructor(public carousel: CarouselComponent, @Inject(LIB_CONFIG) private config: LibConfig) {
    this.strapiUrl = this.config.strapiURL;
    this.updateCopy();
  }

  ngOnInit() {
    this.media.mediaType = this.media?.src?.url?.endsWith('.mp4') ? 'video' : 'image';    
    this.carouselSubscription = this.carousel.slideEvent.subscribe(() => {
      this.updateCopy();
    });
  }

  onNext() {
    this.carousel.next();
  }

  onPrev() {
    this.carousel.prev();
  }

  updateCopy() {
    this.prevCopy = this.carousel.currentPrevCopy;
    this.nextCopy = this.carousel.currentNextCopy;
  }

  ngOnDestroy() {
    if (this.carouselSubscription) {
      this.carouselSubscription.unsubscribe();
    }
  }

  openModalOrNextStep(e, uid): boolean {
    if (this.modal?.modalTitle) {
      e.preventDefault();
      this.issecondaryModalOpen = true;
      return false;
    } else {
      this.nextAction = {
        id: this.actions[0]?.id,
        uid,
      };
      this.next.emit(this.nextAction);
    }
  }

  onModalNext(nextAction) {
    this.nextAction = nextAction;
    if (nextAction.uid === 'CLOSE_MODAL') {
      this.issecondaryModalOpen = false;
    } else {
      this.modalNext.emit(nextAction);
    }
  }
}
